/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateManualNumericInputDto
 */
export interface UpdateManualNumericInputDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateManualNumericInputDto
     */
    inputValue?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateManualNumericInputDto
     */
    $type?: UpdateManualNumericInputDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateManualNumericInputDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoUpdateManualNumericInputDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateManualNumericInputDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateManualNumericInputDtoTypeEnum = typeof UpdateManualNumericInputDtoTypeEnum[keyof typeof UpdateManualNumericInputDtoTypeEnum];



/**
 * Check if a given object implements the UpdateManualNumericInputDto interface.
 */
export function instanceOfUpdateManualNumericInputDto(value?: unknown): value is UpdateManualNumericInputDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateManualNumericInputDtoTypeEnum)[0];
}

export function UpdateManualNumericInputDtoFromJSON(json: any): UpdateManualNumericInputDto {
    return UpdateManualNumericInputDtoFromJSONTyped(json, false);
}

export function UpdateManualNumericInputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateManualNumericInputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'inputValue': json['inputValue'] == null ? undefined : json['inputValue'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UpdateManualNumericInputDtoToJSON(value?: UpdateManualNumericInputDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'inputValue': value['inputValue'],
        '$type': value['$type'],
    });
}

